'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = getPaginationPrevNext;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _url = require('url');

var _queryString = require('query-string');

var _lodashOmit = require('lodash.omit');

var _lodashOmit2 = _interopRequireDefault(_lodashOmit);

var integerRegex = /^[1-9]\d*$/;

function buildUrl(path, query) {
  var queryStr = (0, _queryString.stringify)(query);

  if (queryStr !== '') {
    queryStr = '?' + queryStr;
  }

  return '' + path + queryStr;
}

function getPaginationPrevNext(_ref) {
  var url = _ref.url;
  var lastPageNumber = _ref.lastPageNumber;

  if (lastPageNumber <= 1) {
    return {};
  }

  var _parse = (0, _url.parse)(url, /* parse the query string to an object */true);

  var protocol = _parse.protocol;
  var host = _parse.host;
  var pathname = _parse.pathname;
  var query = _parse.query;

  var lowercasedPageQuery = Object.keys(query).reduce(function (result, key) {
    if (key.toLowerCase() === 'page') {
      result.page = query[key];
    } else {
      result[key] = query[key];
    }

    return result;
  }, {});
  var _lowercasedPageQuery$page = lowercasedPageQuery.page;
  var page = _lowercasedPageQuery$page === undefined ? '' : _lowercasedPageQuery$page;

  var pageNumber = integerRegex.test(page) ? parseInt(page, 10) : 1;
  var path = protocol + '//' + host + pathname;
  var result = {};

  if (pageNumber === 2) {
    result.prev = buildUrl(path, (0, _lodashOmit2['default'])(lowercasedPageQuery, 'page'));
  } else if (pageNumber > 2 && pageNumber <= lastPageNumber) {
    result.prev = buildUrl(path, _extends({}, lowercasedPageQuery, { page: pageNumber - 1 }));
  } else if (page > lastPageNumber) {
    result.prev = buildUrl(path, _extends({}, lowercasedPageQuery, { page: lastPageNumber }));
  }

  if (pageNumber < lastPageNumber) {
    result.next = buildUrl(path, _extends({}, lowercasedPageQuery, { page: pageNumber + 1 }));
  }

  return result;
}

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-seo/build/get-pagination-prev-next.js
 ** module id = 556
 ** module chunks = 0
 **/